import { NgModule } from '@angular/core';
import { PipelineMultiSelectComponent } from './pipeline-multi-select.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { VaFormsModule } from '@vendasta/forms';
import { PipelineMultiSelectService } from './pipeline-multi-select.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [PipelineMultiSelectComponent],
  exports: [PipelineMultiSelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    TranslateModule,
    VaFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
  ],
  providers: [PipelineMultiSelectService],
})
export class PipelineMultiSelectModule {}
